import { render } from "./SeparatorComponent.vue?vue&type=template&id=50020906&scoped=true"
const script = {}

import "./SeparatorComponent.vue?vue&type=style&index=0&id=50020906&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50020906"]])

export default __exports__